import React from 'react';
import { useLocation } from 'react-router-dom';
import LPLink from '../components/Common/LPLink';
import {
    Button,
    Container,
    Theme,
    Typography
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const ErrorPage: React.FC = () => {
    const location = useLocation();

    const useStyles = makeStyles()((theme: Theme) => ({
            container: {
                marginTop: theme.spacing(10),
                textAlign: 'center',
            },
            errorTitle: {
                color: theme.palette.error.main,
                fontWeight: 'bold',
                marginBottom: theme.spacing(2),
            },
            errorDescription: {
                marginBottom: theme.spacing(4),
            },
            homeButton: {
                marginTop: theme.spacing(2),
            },
        })
    );

    const { classes } = useStyles();

    let params = new URLSearchParams(location.search);

    return (
        <Container className={classes.container}>
            <Typography variant="h4" className={classes.errorTitle}>
                Oops! Something went wrong.  Please contact support.
            </Typography>

            <Typography variant="h6" className={classes.errorDescription}>
                Error: {params.get('error') || 'Unknown Error'}
            </Typography>

            <Typography variant="h6" className={classes.errorDescription}>
                Error Description: {params.get('errorDescription') || 'No description available.'}
            </Typography>

            <Button
                variant="contained"
                color="secondary"
                className={classes.homeButton}
                component={LPLink}
                to="/"
            >
                Go Back to Home
            </Button>
        </Container>
    );
};

export default ErrorPage;